<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="80%">
      <v-card>
        <v-card-title>
          <span class="headline">Escolha o tipo de layout para o novo quadro</span>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-row
              align="stretch"
              justify="center"
              style="height: 100%;"
          >
            <v-col
                @click="carregaTipoLayoutSelecionado(1)"
                cols="4"
            >
              <Layout1
                  exibindo-em="selecionaLayout"
                  style="cursor: pointer"
              ></Layout1>
            </v-col>

            <v-col
                @click="carregaTipoLayoutSelecionado(2)"
                cols="4"
            >
              <Layout2
                  exibindo-em="selecionaLayout"
                  style="cursor: pointer"
              ></Layout2>
            </v-col>

            <v-col
                @click="carregaTipoLayoutSelecionado(3)"
                cols="4"
            >
              <Layout3
                  exibindo-em="selecionaLayout"
                  style="cursor: pointer"
              ></Layout3>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="dialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
        @click="abreModalSelecaoLayout()"
        fab
        color="blue"
        class="mt-4 mx-3"
    >
      <v-icon title="Adicionar quadro">
        mdi-shape-square-plus
      </v-icon>
    </v-btn>

  </div>

</template>

<script>

import Layout1 from "../layouts/layout1";
import Layout2 from "../layouts/layout2";
import Layout3 from "../layouts/layout3";

export default {
  name: "SelecionaLayout",
  components: {Layout3, Layout2, Layout1},
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    abreModalSelecaoLayout() {
      this.dialog = true;
    },

    carregaTipoLayoutSelecionado(layoutTipoId) {
      let timelineItem = {
        tempoExibicao: 8,
        layoutTipoId: layoutTipoId,
      };

      this.$store.dispatch('addTimelineItem', timelineItem);

      this.dialog = false;
    },
  },
}
</script>
